import { DELETE_SESSION, FETCH_USER, LOGIN } from '@/utils/store/actionTypes'
import { SET_AUTH_TOKEN, SET_REDIRECT_URL, LOGOUT } from '@/utils/store/mutationTypes'
import { getCookieDomain } from '@/utils/cookie'
import { identifyUserEvent } from '@/utils/account'
import { datadogRum } from '@datadog/browser-rum'

export default ({ app, store, redirect, route }, inject) => {
  app.auth = {}

  app.auth.login = async ({ username, password, url, disableUserFetching = false, disableRedirect = false }) => {
    const response = await store.dispatch(`auth/${LOGIN}`, { username, password })

    app.$cookies.set('apollo-token', response.token, {
      path: '/',
      expires: new Date(Date.now() + 432000),
      maxAge: 60 * 60 * 24 * 5,
      domain: getCookieDomain()
    })

    app.$cookies.set('apollo-expires', response.token_expires_at, {
      path: '/',
      expires: new Date(Date.now() + 432000),
      maxAge: 60 * 60 * 24 * 5,
      domain: getCookieDomain()
    })

    if (!disableUserFetching) {
      try {
        const user = await store.dispatch(`auth/${FETCH_USER}`)

        if (user?.user?._id) {
          identifyUserEvent({ otaUserId: `${user?.user?._id}` })
        }
      } catch (error) {
        app.$cookies.remove('apollo-token', {
          path: '/',
          domain: getCookieDomain()
        })

        app.$cookies.remove('apollo-expires', {
          path: '/',
          domain: getCookieDomain()
        })
      }
    }

    if (!route.query.chatId && !disableRedirect) {
      redirect(`/${store.state.app.locale}-${store.state.app.country}${route.query.next ?? url}`)
    }

    if (store.state.auth.redirectUrl !== '/account') {
      store.commit(`auth/${SET_REDIRECT_URL}`, { url: '/account' })
    }

    return response
  }

  app.auth.setUserToken = (token) => {
    app.$cookies.set('apollo-token', token, {
      path: '/',
      expires: new Date(Date.now() + 432000),
      maxAge: 60 * 60 * 24 * 5,
      domain: getCookieDomain()
    })

    store.commit(`auth/${SET_AUTH_TOKEN}`, { token })
  }

  app.auth.logout = ({ redirectUrl = '/login' } = {}) => {
    const token = app.$cookies.get('apollo-token')

    store.dispatch(`user/${DELETE_SESSION}`, { token }).catch((deleteSessionError) => {
      app.$ota.general.logError(deleteSessionError)
    })

    app.$apolloHelpers.onLogout()

    store.commit(`auth/${LOGOUT}`)

    app.$cookies.remove('apollo-expires', {
      path: '/',
      domain: getCookieDomain()
    })
    app.$cookies.remove('apollo-token', {
      path: '/',
      domain: getCookieDomain()
    })

    datadogRum.clearUser()

    redirect(`/${store.state.app.locale}-${store.state.app.country}${redirectUrl}`)
  }

  inject('auth', app.auth)
}
